import Collection from './generic/collection'
import { FetchData } from './utils/fetchData'
import Preloader from './preloader'
import { onAjaxContentLoaded } from "./generic/evented";

class AddToFavorites {
    constructor(instance) {
        this.instance = instance
        this.bindEvents()
    }

    toggleActive(response) {
        try {
            if (response.success) {
                this.instance.classList.toggle('active')
                console.debug('Success');
            }
        } catch {
            console.debug('Error in request data')
        }
    }

    async add(evt) {
        evt.stopPropagation()
        evt.preventDefault()
        const linkId = this.instance.dataset.jsAddToFav;
        const ajaxUrl = this.instance.dataset.jsAjaxUrl;
        const response = await FetchData.postData({ data: linkId }, ajaxUrl)

        if (response.success) {
            this.toggleActive(response)
            Preloader.hide();
        }
    }

    bindEvents() {
        this.instance.addEventListener('click', (e) => this.add(e))
    }
}

export class AddToFavoritesCollection extends Collection {
    static selectors = {
        instance: '[data-js-add-to-fav]',
    }

    constructor() {
        super(AddToFavoritesCollection.selectors.instance, AddToFavorites)
        this.bindEvents();
    }

    bindEvents() {
        onAjaxContentLoaded(() => {
            this.init()
        })
    }

    init() {
        $(AddToFavoritesCollection.selectors.instance).each((index, el) => {
            this.collection = new AddToFavorites(el)
        })
    }
}
